import React from "react";
import RippleEffect from "../../RippleEffect/RippleEffect";
import styled from "styled-components";
import { ITheme } from "../../Themes/ThemeTypes";
import { RippleEffectShapeEnum } from "../../RippleEffect/RippleEffectShapeEnum";
import Icon from "../../Icon/Icon";
import { ThemeColorEnum, ThemeIconEnum } from "../../Themes/ThemeEnums";

const Button = styled.button<{ theme: ITheme; $isDisabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-inline-size: 64px;
  outline: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  user-select: none;
  appearance: none;
  vertical-align: middle;
  background: transparent;
  border: 1px solid
    ${(props) =>
      props.$isDisabled
        ? `rgba(${props.theme.colors.on_surface}, ${props.theme.base.opacity.disabled_container})`
        : `rgb(${props.theme.colors.outline})`};
  text-decoration: none;
  position: relative;
  z-index: ${(props) => props.theme.base.z_index.base};
  height: 40px;
  font-family: ${(props) => props.theme.base.typography.font};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  color: ${(props) =>
    props.$isDisabled
      ? `rgba(${props.theme.colors.on_surface}, ${props.theme.base.opacity.disabled_content})`
      : `rgb(${props.theme.colors.primary})`};
  gap: 8px;
  padding-inline-start: 24px;
  padding-inline-end: 24px;
  border-radius: ${(props) => props.theme.base.button.radius};
  line-height: 40px;
  overflow: hidden;
  white-space: nowrap;
  cursor: ${(props) => (props.$isDisabled ? "not-allowed" : "pointer")};

  &:before {
    content: "";
    position: absolute;
    inset: 0;
    background-color: rgb(${(props) => props.theme.colors.primary});
    opacity: 0;
    transition: opacity ${(props) => props.theme.base.motion.duration.short4}ms
      ${(props) => props.theme.base.motion.easing.standard};
  }

  &:hover:before {
    opacity: ${(props) => (props.$isDisabled ? 0 : props.theme.base.opacity.hover_state_layer)};
  }
`;

interface OutlinedButtonProps {
  label: string;
  icon?: ThemeIconEnum;
  disabled?: boolean;
  onClick?: () => void;
}

const OutlinedButton: React.FC<OutlinedButtonProps> = ({ label, icon, disabled, onClick }) => {
  const handleClick = () => {
    if (!disabled && onClick) onClick();
  };

  return (
    <RippleEffect shape={RippleEffectShapeEnum.BUTTON}>
      <Button $isDisabled={disabled} onClick={handleClick}>
        {icon !== undefined && <Icon icon={icon} color={ThemeColorEnum.PRIMARY} />}
        {label}
      </Button>
    </RippleEffect>
  );
};

export default OutlinedButton;
